"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobileGroups = exports.Community = exports.Docs = void 0;

var _react = _interopRequireDefault(require("react"));

var _NavMenu = require("../NavMenu");

var _ColoredIcon = require("../ColoredIcon");

var Docs = function Docs(_ref) {
  var active = _ref.active,
      inverse = _ref.inverse,
      monochrome = _ref.monochrome,
      navLinks = _ref.navLinks;
  return /*#__PURE__*/_react["default"].createElement(_NavMenu.NavMenu, {
    label: "Docs",
    inverse: inverse,
    monochrome: monochrome,
    active: active
  }, /*#__PURE__*/_react["default"].createElement(_NavMenu.NavMenuItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
      icon: "book",
      color: "green"
    }),
    description: "Learn everything you need to know to use Storybook",
    href: navLinks.guides.url,
    LinkWrapper: navLinks.guides.linkWrapper
  }, "Guides"), /*#__PURE__*/_react["default"].createElement(_NavMenu.NavMenuItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
      icon: "compass",
      color: "gold"
    }),
    description: "Follow guided walkthroughs on for Storybook\u2019s key workflows",
    href: navLinks.tutorials.url,
    LinkWrapper: navLinks.tutorials.linkWrapper
  }, "Tutorials"), /*#__PURE__*/_react["default"].createElement(_NavMenu.NavMenuItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
      icon: "verified",
      color: "green"
    }),
    description: "Release notes for all major and minor Storybook versions",
    href: navLinks.changelog.url,
    LinkWrapper: navLinks.changelog.linkWrapper
  }, "Changelog"));
};

exports.Docs = Docs;

var Community = function Community(_ref2) {
  var active = _ref2.active,
      inverse = _ref2.inverse,
      monochrome = _ref2.monochrome,
      navLinks = _ref2.navLinks;
  return /*#__PURE__*/_react["default"].createElement(_NavMenu.NavMenu, {
    label: "Community",
    inverse: inverse,
    monochrome: monochrome,
    active: active
  }, /*#__PURE__*/_react["default"].createElement(_NavMenu.NavMenuItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
      icon: "starhollow",
      color: "gold"
    }),
    description: "Join thousands of frontend devs to learn and share",
    href: navLinks.getInvolved.url,
    LinkWrapper: navLinks.getInvolved.linkWrapper
  }, "Get involved"), /*#__PURE__*/_react["default"].createElement(_NavMenu.NavMenuItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
      icon: "rss",
      color: "purple"
    }),
    description: "News and updates from the Storybook team",
    href: navLinks.blog.url,
    LinkWrapper: navLinks.blog.linkWrapper
  }, "Blog and updates"));
};

exports.Community = Community;

var mobileGroups = function mobileGroups(links) {
  return [{
    label: 'Why',
    items: [{
      label: 'Why Storybook',
      link: links.whyStorybook,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "storybook",
        color: "primary"
      })
    }, {
      label: 'Component-driven UI',
      link: links.componentDriven,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "componentdriven",
        color: "purple"
      })
    }]
  }, {
    label: 'Docs',
    items: [{
      label: 'Guides',
      link: links.guides,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "book",
        color: "green"
      })
    }, {
      label: 'Tutorials',
      link: links.tutorials,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "compass",
        color: "gold"
      })
    }, {
      label: 'Changelog',
      link: links.changelog,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "check",
        color: "green"
      })
    }]
  }, {
    label: 'Showcase',
    items: [{
      label: 'Explore',
      link: links.showcase,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "admin",
        color: "green"
      })
    }, {
      label: 'Projects',
      link: links.projects,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "book",
        color: "primary"
      })
    }, {
      label: 'Component glossary',
      link: links.componentGlossary,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "component",
        color: "secondary"
      })
    }]
  }, {
    label: 'Community',
    items: [{
      label: 'Addons',
      link: links.integrations,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "grid",
        color: "seafoam"
      })
    }, {
      label: 'Get involved',
      link: links.getInvolved,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "starhollow",
        color: "gold"
      })
    }, {
      label: 'Blog',
      link: links.blog,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "rss",
        color: "purple"
      })
    }]
  }, {
    label: 'Chromatic',
    items: [{
      label: 'Visual testing',
      link: links.chromatic,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "chromatic",
        color: "orange"
      })
    }, {
      label: 'Enterprise',
      link: links.enterprise,
      icon: /*#__PURE__*/_react["default"].createElement(_ColoredIcon.ColoredIcon, {
        icon: "admin",
        color: "midnight"
      })
    }]
  }];
};

exports.mobileGroups = mobileGroups;